import styled from 'styled-components';

import { ActionsContainer } from '#/components/rfq-common/TableRow';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';

export const RfqActionRow = styled(ActionsContainer)`
  grid-template-areas: 'bqty bkill bid mark ask akill aqty';
  grid-template-columns: 74px 10px 90px 90px 90px 10px 74px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    grid-template-columns: 7fr 1fr 8fr 7fr 8fr 1fr 7fr;
  }
`;
